import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Link } from 'gatsby';
import cx from 'classnames';
import M6Banner from '../../LandingProgram/M6Banner';
import Image from 'components/common/utils/Image';
import DefaultHeader from './DefaultHeader';
import config from 'utils/siteConfig';
import FooterAccordion from "components/common/FooterAccordion";

import {
  endFooterLinks, footerLinks
} from './data';
// Styles
import './fonts.sass';
import './styles.sass';
import { CookiesProvider } from 'react-cookie';
import Cta from 'components/common/Cta';
import { Container } from "react-bootstrap";
import { useSatismeterScore } from "hooks/useSatismeterScore";
import { useIntercom } from 'react-use-intercom';
import useCharlesIntercom from 'components/common/utils/IntercomWrapper/useCharlesIntercom';

// TODO LUCAS REFACTOR
const dropCategory = (index, target) => {
  const listId = `${target}List${index}`;
  const tagId = `${target}Tag${index}`;
  const list = document.getElementById(listId);
  const tag = document.getElementById(tagId);
  list.classList.toggle(`expand-${target}-list`);
  tag.classList.toggle(`rotate-${target}-tag`);
}

/**
 * Main layout component
 *
 * The Layout component wraps around each page and template.
 * It also provides the header, footer as well as the main
 * styles, and meta data for each page.
 *
 */
const CharlesLayout = ({
  children,
  bodyClass = '',
  showBars = true,
  showM6Banner = true,
  showLinksInFooter = true,
  showStickyNavbar = true,
  showOnlyFooter = false,
  showIntercom = true,
  footerCtaPath = '/consulter/',
  footerCtaLabel = "Consultez un médecin",
  showReinsuranceInFooter = true,
}) => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
    return () => {
      document.documentElement.style.scrollBehavior = "auto";
    }
  }, []);

  const {
    ratingValue,
    ratingCount,
    maxRating,
    reload
  } = useSatismeterScore();

  useEffect(() => {
    setInterval(() => {
      reload();
    }, 60 * 1000);
  }, []);

  useCharlesIntercom(showIntercom)

  return (
    <CookiesProvider>
      <Helmet defer={false}>
        <body className={bodyClass} />

      </Helmet>
      <div className="viewport">
        <div className="viewport-top">
          {/* The main header section on top of the screen */}
          {!showOnlyFooter && showBars && (
            <DefaultHeader showStickyNavbar={showStickyNavbar} />
          )}
          <main
            className={cx('charles-main', {
              'with-navbar': showBars,
              'without-sticky-navbar': !showStickyNavbar,
            })}
          >
            {/* All the main content gets inserted here, index.js, post.js */}
            {children}
          </main>
        </div>
        <div className="viewport-bottom">
          {/* The footer at the very bottom of the screen */}
          {(showOnlyFooter || showBars) && (
            <footer className="charles-footer">
              {showLinksInFooter && (
                <div className="landing-footer-blog-section">
                  <div className="landing-footer-blog-section-text-cta">
                    <div className="landing-footer-blog-section-text">
                      <h2 className="landing-footer-blog-section-h2">Comprendre sur le blog</h2>
                      <div className="landing-footer-blog-section-subtitle">
                        Nos spécialistes répondent à toutes vos questions.
                      </div>
                    </div>
                  </div>
                  <div className="landing-footer-blog-section-link-wrapper">
                    {footerLinks.map((category, i) => (
                      <div
                        className="landing-footer-blog-section-link-category"
                        key={`category-link-${i}`}
                      >
                        <div className="landing-footer-blog-section-link-category-title">
                          <a href={category.link}>
                            <div className="h4">{category.title}</div>
                          </a>
                          <Image
                            id={`blogTag${i}`}
                            filename="new-images/tag.svg"
                            alt="fleche-haut-picto"
                            title="fleche haut picto"
                            className="landing-footer-blog-section-link-category-tag"
                            onClick={() => dropCategory(i, 'blog')}
                          />
                        </div>
                        <ul id={`blogList${i}`} className="landing-footer-blog-section-link-list">
                          {category.links.map((link, j) => (
                            <li key={`blogList${i}-${j}`}>
                              {' '}
                              {link.to ? (
                                <Link
                                  to={link.to}
                                  rel="noopener noreferrer"
                                  className="category-info"
                                  title={link.ref || ''}
                                >
                                  {link.title}
                                </Link>
                              ) : (
                                <span>{link.title}</span>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                  <Cta text="Voir tout le blog" path="/blog/" className="new-secondary-black-cta landing-footer-blog-section-cta " />
                </div>
              )}
              <div className={cx('landing-footer-end-footer-section', { 'hidden-blog-links': !showLinksInFooter })}>
                <div className={cx('landing-footer-end-footer-section-reinsurance', { 'd-none d-xl-flex': !showReinsuranceInFooter })}>
                  <div className="footer-section-reinsurance-content-wrapper">
                    <Image
                      filename="new-images/thumb-up.svg"
                      alt="thumb-up-picto"
                      title="thumb up picto"
                    />
                    <div className="h4 footer-section-reinsurance-content-text">
                      50 000 patients ont fait confiance à nos experts, pourquoi pas vous...
                    </div>
                  </div>
                  <Cta text={footerCtaLabel} className="new-primary-cta" path={footerCtaPath} />
                </div>
                <div className="landing-footer-end-footer-section-desktop-row">
                  <div className="landing-footer-end-footer-section-logo-wrapper d-xl-none">
                    <Image
                      aria-label="logo charles clinique digitale"
                      filename="new-images/round-logo.svg"
                      className="landing-footer-end-footer-section-logo"
                      alt="charles-clinique-digitale-logo-circulaire"
                      title="charles clinique digitale logo circulaire"
                    />
                    <div className="landing-footer-end-footer-section-social d-xl-none">
                      <a href="https://www.facebook.com/charlescofr/" rel="noopener noreferrer nofollow">
                        <Image filename="new-images/logo/facebook.svg" className="landing-footer-end-footer-section-social-logo" alt="facebook-picto-2" title="facebook picto-2" />
                      </a>
                      <a href="https://www.linkedin.com/company/charleshealth/" rel="noopener noreferrer nofollow">
                        <Image filename="new-images/logo/linkedin-in.svg" className="landing-footer-end-footer-section-social-logo" alt="linkedin-picto-2" title="linkedin picto-2" />
                      </a>
                      <a href="https://www.instagram.com/charles.co/" rel="noopener noreferrer nofollow">
                        <Image filename="new-images/logo/instagram.svg" className="landing-footer-end-footer-section-social-logo" alt="instagram-picto-2" title="instagram picto-2" />
                      </a>
                      <a href="https://www.youtube.com/channel/UCpEfF_Jfp0SozH6uZ0PNw5Q/" rel="noopener noreferrer nofollow">
                        <Image filename="new-images/logo/youtube.svg" className="landing-footer-end-footer-section-social-logo" alt="youtube-picto-2" title="youtube picto-2" />
                      </a>
                    </div>
                  </div>
                  <div className="landing-footer-end-footer-section-question">
                    <div className="h4">Vous avez une question ?</div>
                    <div className="landing-footer-end-footer-section-question-wrapper">
                      <div className="landing-footer-end-footer-section-question-line">
                        <div className="footer-icon-wrapper d-flex justify-content-center">
                          <Image filename="new-images/mobile.svg" alt="mobile-picto" title="mobile picto" />
                        </div>
                        <a href="tel:01 86 65 17 33">01 86 65 17 33</a>

                      </div>
                      <div className="landing-footer-end-footer-section-question-line">
                        <div className="footer-icon-wrapper d-flex justify-content-center">
                          <Image filename="new-images/envelope.svg" alt="enveloppe-picto" title="enveloppe picto" />
                        </div>
                        <a href="mailto:contact@charles.co">contact@charles.co</a>

                      </div>
                      <div className="landing-footer-end-footer-section-question-line">
                        <div className="footer-icon-wrapper d-flex justify-content-center">
                          <Image filename="new-images/book.svg" alt="livre-picto" title="livre picto" />
                        </div>
                        <Link to="/faq/">FAQ</Link>

                      </div>
                    </div>
                    <div className="landing-footer-end-footer-section-social d-none d-xl-flex">
                      <a href="https://www.facebook.com/charlescofr/" target="_blank" rel="noopener noreferrer nofollow">
                        <Image
                          filename="new-images/logo/facebook.svg"
                          className="landing-footer-end-footer-section-social-logo"
                          alt="facebook-picto"
                          title="facebook picto"
                        />
                      </a>
                      <a href="https://www.linkedin.com/company/charleshealth/" target="_blank" rel="noopener noreferrer nofollow">
                        <Image
                          filename="new-images/logo/linkedin-in.svg"
                          className="landing-footer-end-footer-section-social-logo"
                          alt="linkedin-picto"
                          title="linkedin picto"
                        />
                      </a>
                      <a href="https://www.instagram.com/charles.co/" target="_blank" rel="noopener noreferrer nofollow">
                        <Image
                          filename="new-images/logo/instagram.svg"
                          className="landing-footer-end-footer-section-social-logo"
                          alt="instagram-picto"
                          title="instagram picto"
                        />
                      </a>
                      <a href="https://www.youtube.com/channel/UCpEfF_Jfp0SozH6uZ0PNw5Q/" target="_blank" rel="noopener noreferrer nofollow">
                        <Image
                          filename="new-images/logo/youtube.svg"
                          className="landing-footer-end-footer-section-social-logo"
                          alt="youtube-picto"
                          title="youtube picto"
                        />
                      </a>
                    </div>
                    <Image filename="new-images/round-logo.svg" className="d-none d-xl-block landing-footer-end-footer-section-logo"
                      alt="round-logo" title="round logo" />
                  </div>
                  <Container>
                    <FooterAccordion sections={endFooterLinks()} wideGapItems />
                  </Container>
                </div>
                <div className="landing-footer-under-section-wrapper">
                  <div className="landing-footer-under-section">
                    <div className="footer-under-section-left">
                      <Link className="under-section-item" to="/politique-de-confidentialite/">Politique de confidentialité</Link>
                      <Link className="under-section-item" to="/conditions-generales/">Mentions légales</Link>
                    </div>
                    <div className="footer-under-section-right">
                      <div className="under-section-item">Sur {ratingCount} avis, Charles.co a obtenu la note de {`${ratingValue}`.replace(".", ",")}/{maxRating}</div>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          )}
        </div>
        {showM6Banner && <M6Banner />}
      </div>
    </CookiesProvider>
  );
};

CharlesLayout.propTypes = {
  children: PropTypes.node.isRequired,
  bodyClass: PropTypes.string,
  showBars: PropTypes.bool,
  showOnlyFooter: PropTypes.bool,
};

export default CharlesLayout;
